import React from "react";
import "../../../assets/css/style.css";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import {useDispatch, useSelector} from "react-redux";
import {CiSquareChevRight} from "react-icons/ci";
import {CiSquareChevLeft} from "react-icons/ci";

const ProgressBar = ({current, total}) => {
  const progressPercentage = (current / total) * 100;
  const dispatch = useDispatch();

  const {proposalStep} = useSelector(selectDataStoreState);

  return (
    <>
      <div className="progressBarMain">
        {/* <CiSquareChevLeft
          onClick={() => {
            current > 1 &&
              dispatch(
                setDataStore({
                  proposalStep: proposalStep - 1,
                })
              );
          }}
        /> */}
        <span className="progress-label">
          {current} of {total}
        </span>{" "}
        {/* <CiSquareChevRight
          onClick={() => {
            current < 12 &&
              dispatch(
                setDataStore({
                  proposalStep: proposalStep + 1,
                })
              );
          }}
        /> */}
      </div>
      <div className="progress-container">
        <div
          className="progress-bar"
          style={{width: `${progressPercentage}%`}}
        ></div>
      </div>
    </>
  );
};

export default ProgressBar;
